import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import {
    DialogSelectYoungInscriptionDuplicateComponent
} from './dialog-select-young-inscription-duplicate/dialog-select-young-inscription-duplicate.component';
import {
    DialogSelectYoungInscriptionFamilyComponent
} from './dialog-select-young-inscription-family/dialog-select-young-inscription-family.component';
import {DialogConfirmComponent} from './dialog-confirm/dialog-confirm.component';
import {DialogDefaultComponent} from './dialog-default/dialog-default.component';
import {SharedModule} from '../shared.modules';
import {DialogRgpdAcceptComponent} from './dialog-rgpd-accept/dialog-rgpd-accept.component';
import {DialogSelectCenterComponent} from './dialog-select-center/dialog-select-center.component';
import {InscriptionModule} from '../../components/inscription/inscription.module';

import {CustomAgGridModule} from '../ag-grid/custom-ag-grid.module';
import {DialogRightsComponent} from './dialog-rights/dialog-rights.component';
import {DialogAuthorisationComponent} from './dialog-authorisation/dialog-authorisation.component';
import {DialogAttestationComponent} from './dialog-attestation/dialog-attestation.component';
import {DialogRefreshAppComponent} from './dialog-refresh-app/dialog-refresh-app.component';

const DIALOG_COMPONENTS = [
    DialogSelectYoungInscriptionDuplicateComponent,
    DialogSelectYoungInscriptionFamilyComponent,
    DialogConfirmComponent,
    DialogDefaultComponent,
    DialogRgpdAcceptComponent,
    DialogSelectCenterComponent,
    DialogRightsComponent,
    DialogAuthorisationComponent,
    DialogRefreshAppComponent
];

@NgModule({
    imports: [
    CommonModule,
    SharedModule,
    MatDialogModule,
    InscriptionModule,
    CustomAgGridModule,
    DialogAttestationComponent,
    ...DIALOG_COMPONENTS
],
    exports: [
        ...DIALOG_COMPONENTS
    ]
})
export class DialogModule {
}

